<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div
      class="search-form btn-2b5a95"
    >
<div class="l-w" :style="{
        height: $store.state.global.isSearchExtend_1
          ? ''
          : $store.state.global.searchFormHeight_1 + 10 + 'px',
      }">
      <el-form
        label-position="right"
        :class="$store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'"
				:model="searchForm"
				@submit.native.prevent
      >
        <el-form-item label="甲方:">
          <el-input 
						v-model.trim="searchForm.partya" 
						@keyup.enter.native="seach"
						clearable
						></el-input>
        </el-form-item>
        <el-form-item label="乙方:">
          <el-input 
						v-model.trim="searchForm.partyb"
						@keyup.enter.native="seach"
						 clearable
						></el-input>
        </el-form-item>
        <el-form-item label="合同类型:">
          <el-select 
						clearable 
						v-model="searchForm.type" 
						@keyup.enter.native="seach"
						@visible-change="visibleType"
						ref="selectref"
						placeholder="请选择" >
            <el-option
              v-for="item in contract"
              :key="item.key"
              :value="item.key"
              :label="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合作项目:">
          <el-input 
						v-model.trim="searchForm.project" 
						@keyup.enter.native="seach"
						clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
      <div class="r-w">

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="seach"
        :loading="!$store.state.global.isEndRequest"
        class="btn-2b5a95"
        >搜索</el-button
      >
			<el-button type="primary" @click="resetQuery">重置</el-button>
      <el-button
        type="primary"
        :icon="
          $store.state.global.isSearchExtend_1
            ? 'el-icon-arrow-up'
            : 'el-icon-arrow-down'
        "
        v-if="$store.state.global.searchExtend_1"
        class="btn-2b5a95"
        @click="onExtendClick('isSearchExtend_1')"
        >{{ $store.state.global.searchExtendText_1 }}</el-button
      >
    </div>

    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
      stripe
      border
      :header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        label="标题"
        prop="title"
        align="center"
      >
      
        <template slot-scope="scope">
          <el-button @click="btnShowDetail(scope.row)" type="text"
            >{{scope.row.title}}</el-button
          >
        </template>
      
      </el-table-column>
      <el-table-column
        label="甲方"
        prop="partya"
        align="center"
      ></el-table-column>
      <el-table-column
        label="乙方"
        prop="partyb"
        align="center"
      ></el-table-column>
      <el-table-column
        label="合同类型"
        prop="typeval"
        align="center"
      ></el-table-column>
      <el-table-column
        label="合同签署人"
        prop="signer"
        align="center"
      ></el-table-column>
      <el-table-column label="合作开始时间" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.cooperationstart1 | formatDate("YYYY-MM-DD hh:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column label="合作结束时间" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.cooperationend1 | formatDate("YYYY-MM-DD hh:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column
        label="合作项目"
        prop="project"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center" class-name="btn-2b5a95">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="downloadFile(scope.row)"
            >下载合同</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!--添加，修改-->
    <el-dialog
      class="btn-2b5a95"
			width="50%"
			v-dialogDrag
			:close-on-click-modal='false'
      :visible.sync="showAddModal"
      v-if="showAddModal"
      append-to-body
			:title="this.dialogTitle"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="35%"
        class="demo-dynamic form-item-w-50"
        status-icon
        :rules="rules"
      >
        <el-form-item label="标题:" prop="title">
          <el-input v-model.trim="dynamicValidateForm.title" clearable></el-input>
        </el-form-item>
        <el-form-item label="甲方:" prop="partya">
          <el-input v-model.trim="dynamicValidateForm.partya" clearable></el-input>
        </el-form-item>
        <el-form-item label="乙方:" prop="partyb">
          <el-input v-model.trim="dynamicValidateForm.partyb" clearable></el-input>
        </el-form-item>
        <el-form-item label="合同类型:" prop="type">
          <el-select v-model="dynamicValidateForm.typeval" placeholder="请选择" @change="(val,prop)=>onChangeSelect(val,'type')">
            <el-option
              v-for="item in contract"
              :key="item.key"
              :value="item.key"
              :label="item.val"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原合同保管人:" prop="custodian">
          <el-input v-model.trim="dynamicValidateForm.custodian" clearable></el-input>
        </el-form-item>
        <el-form-item label="合同签署人:" prop="signer">
          <el-input v-model.trim="dynamicValidateForm.signer" clearable></el-input>
        </el-form-item>
        <el-form-item label="签署时间:" prop="signertime">
          <el-date-picker
            v-model="dynamicValidateForm.signertime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择签署时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="合作时间始:" prop="cooperationstart">
          <el-date-picker
            v-model="dynamicValidateForm.cooperationstart"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始合作时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="合作时间止:" prop="cooperationend">
          <el-date-picker
            v-model="dynamicValidateForm.cooperationend"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束合作"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="合作项目:" prop="project">
          <el-input v-model.trim="dynamicValidateForm.project" clearable></el-input>
        </el-form-item>
        <el-form-item label="合同:" prop="contracturl">
          <el-input v-model="dynamicValidateForm.contracturl" disabled />
          <el-upload
            class="upload-demo"
            :action="$store.state.global.baseUrl"
            multiple
            :show-file-list="false"
            :before-upload="beforeUpload"
            :http-request="uploadFile"
          >
            <el-button type="primary" class="select-btn">点击上传</el-button>
            <div slot="tip" class="el-upload__tip"></div>
          </el-upload>
        </el-form-item>

        <el-form-item label="合同摘要:">
          <el-input v-model.trim="dynamicValidateForm.remark" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitAddOrEditForm('dynamicValidateForm')"
          :loading="!$store.state.global.isEndRequest"
          >提交
        </el-button>
      </span>
    </el-dialog>

     <!-- 查看详情 -->
    <el-dialog
      class="btn-2b5a95"
      :width="$store.state.global.isFullscreen ? 'width: 100%' : 'width: 80%'"
      :fullscreen="$store.state.global.isFullscreen"
      :visible.sync="showDetailModal"
      v-if="showDetailModal"
      append-to-body
			:close-on-click-modal='false'
      @closed="$store.state.global.isFullscreen = false"
    >
      <span slot="title" class="el-dialog__title">
        <span>详情</span>
        <span
          :class="
            $store.state.global.isFullscreen
              ? 'el-icon-copy-document'
              : 'el-icon-full-screen'
          "
          @click="isExpand($store.state.global.isFullscreen)"
        ></span>
      </span>
      <table border="1" cellpadding="10" cellspacing="0" class="base_table">
            <tr>
							<td>合同类型：{{ dynamicValidateForm.typeval }}</td>
              <td>甲方：{{ dynamicValidateForm.partya }}</td>
              <td>乙方：{{ dynamicValidateForm.partyb }}</td>
            </tr>
            <tr>
              <td>原合同保管人：{{ dynamicValidateForm.custodian }}</td>
              <td>合同签署人：{{ dynamicValidateForm.signer }}</td>
              <td>签署时间：{{ dynamicValidateForm.signertime | formatDate("YYYY-MM-DD") }}</td>
            </tr>
            <tr>
              <td>合作时间始：{{ dynamicValidateForm.cooperationstart | formatDate("YYYY-MM-DD ") }}</td>
              <td>合作时间止：{{ dynamicValidateForm.cooperationend | formatDate("YYYY-MM-DD ")  }}</td>
              <td>合作项目：{{ dynamicValidateForm.project }}</td>
            </tr>
             <tr>
              <td>合同摘要：{{ dynamicValidateForm.remark }}</td>
              <td>录入时间：{{ dynamicValidateForm.inserttime | formatDate("YYYY-MM-DD ") }}</td>
							<td>录入人姓名：{{ dynamicValidateForm.insertusername }}</td>
            </tr>
             <tr>
              <td>所属教学点名称：{{ dynamicValidateForm.schoolorgname }}</td>
              <td>所属分公司名称：{{ dynamicValidateForm.companyorgname }}</td>
							<td>流水号： {{dynamicValidateForm.id}}</td>
            </tr>
             <tr>
              <td>
								<template>
									<div class="flex-image" style="display: flex;align-items: center;">
										合同：
											<el-image
											:src="$url.upload+dynamicValidateForm.contracturl"
											style="width: 70px; height: 70px; margin-left: 10px;"
											/>
									</div>
								</template>
							</td>
              <td>标题：{{ dynamicValidateForm.title }}</td>
							<td></td>
            </tr>
          </table>
    </el-dialog>
  </div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";

import {
  contract_list,
  contract_input,
  contract_save,
  contract_delete,
} from "@/request/api/allChildrenProject";
import { _fileupload_save, _filedownload_save } from "@/request/api/public";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";

export default {
  mixins: [part],
  name: "contract",
  components: {},
  props: {},
  data() {
    //数值表单规则
    var checkfield = (rule, value, callback) => {
      if (!(value + "")) {
        return callback(new Error("必填字段"));
      } else {
        if (isNaN(Number(value))) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }
    };
    return {
      itemId: null, //首表格项id
      searchForm: {},
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showAddModal: false, //显示表单框
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {}, //表单
      rules: {
        title: [{ trigger: "blur", message: "必填字段", required: true }],
        partya: [{ trigger: "blur", message: "必填字段", required: true }],
        partyb: [{ trigger: "blur", message: "必填字段", required: true }],
        type: [{ trigger: "blur", message: "必填字段", required: true }],
        custodian: [{ trigger: "blur", message: "必填字段", required: true }],
        signer: [{ trigger: "blur", message: "必填字段", required: true }],
        signertime: [{ trigger: "blur", message: "必填字段", required: true }],
        cooperationstart: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        cooperationend: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        project: [{ trigger: "blur", message: "必填字段", required: true }],
        contracturl: [{ trigger: "blur", message: "必填字段", required: true }],
      }, //表单规则
      dialogTitle: "", //对话框标题
      fds: new FormData(),

      contract: [], //合同类型
      showDetailModal:false,
    };
  },
  created() {
    this.getDataList();
    this.dic_combox({
      list: "contract",
      typecode: "contract",
      that: this,
    });
		window.addEventListener("keyup", this.enterSelect);
  },
  methods: {
    ...mapActions("global", ["onExtendClick",'isExpand']),
    ...mapActions("selectData", ["dic_combox"]),
    //选择器改变 change
    onChangeSelect(val,prop){
      this.dynamicValidateForm[prop] = val
    },
		enterSelect(e) {
			if(e.keyCode == 13) {
				this.getDataList();
			}
		},
		visibleType(e) {
			if(!e) {
				this.$refs.selectref.blur();
			}
		},
		reset() {
			this.searchForm = {
				partya: null,
				partyb: null,
				type: null,
				project: null
			}
		},
		resetQuery() {
			this.reset();
			this.getDataList();
		},
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: contract_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },
    // 查看详情 click
    btnShowDetail(row) {
      this.dynamicValidateForm = JSON.parse(JSON.stringify(row))
      this.showDetailModal = true;
    },
    //添加click
    btnAdd() {
      this.dialogTitle = "添加";
      this.dynamicValidateForm = {
        contracturl: null,
      };
      this.showAddModal = true;
    },
    //修改click
    btnEdit() {
      this.dialogTitle = "修改";
      selectCheck(this.multipleSelection, "修改", false, () => {
        this.editRoutePage(this.multipleSelection[0].id);
      });
    },
    //删除click
    btnDel() {
      selectCheck(this.multipleSelection, "删除", true, () => {
        confirmCallBack({
          title: "提示",
          content: "此操作将永久删除选中的数据！",
          success: () => {
            this.delTableItem(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //上传文件前 before
    beforeUpload(file) {
      this.fds.append("upfile", file); // 传文件
    },
    //上传文件 upload
    uploadFile() {
      myRequest({
        method: "post",
        url: _fileupload_save,
        data: this.fds,
      }).then((res) => {
        if (res.data.code === "200") {
          this.dynamicValidateForm.contracturl = res.data.url;
        }
      });
    },
    //下载 click
    downloadFile(row) {
      location.href =
        this.$url.Freemarker +
        _filedownload_save +
        "?fileurl=" +
        row.contracturl;
    },
    //刷新 click
    btnRefresh() {
      this.getDataList();
    },
    //修改路由页 api
    editRoutePage(id) {
      myRequest({
        url: contract_input,
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.dynamicValidateForm = res.data.data.vcontract;
          delete this.dynamicValidateForm.inserttime; //inserttime 该字段不用传
          delete this.dynamicValidateForm.deleteflag; //deleteflag 该字段不用传
          this.dynamicValidateForm.signertime = formatDare(
            this.dynamicValidateForm.signertime,
            "YYYY-MM-DD HH:mm:ss"
          );
          this.dynamicValidateForm.cooperationstart = formatDare(
            this.dynamicValidateForm.cooperationstart,
            "YYYY-MM-DD HH:mm:ss"
          );
          this.dynamicValidateForm.cooperationend = formatDare(
            this.dynamicValidateForm.cooperationend,
            "YYYY-MM-DD HH:mm:ss"
          );
          this.showAddModal = true;
          console.log(this.dynamicValidateForm)
        }
      });
    },
    //提交-（添加，修改） api
    submitAddOrEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: contract_save,
              data: this.dynamicValidateForm,
            },
            {
              isRefTableList: true,
              that: this,
              
              modal: "showAddModal",
            }
          );
        }
      });
    },
    //删除 api
    delTableItem(idArr) {
      myRequest(
        {
          method: "post",
          url: contract_delete,
          data: this.$qs.stringify(
            {
              ids: idArr,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },
    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style  lang="scss">
	 .base_table{
	  margin: auto;
	 }
</style>